<template>
<div>
    <!-- <div class="vx-col w-full mb-base" id="account-info-col-1"> -->
        <!-- <vx-card class="no-scroll-content" title="Periodic Reports" > -->
                <div class="vx-row" >
                    <div class="vx-col md:w-1/2 w-full md:mt-8" >
                     <div class="w-full mt-8" v-for="(item, index) in reportItems" :key="index" >
                        <vs-checkbox v-model="selected[index]" :vs-value="item.value" class="w-full">{{ item.reportName }}</vs-checkbox>
                     </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5" >
                        <div class="demo-alignment" >
                            <!-- <vs-select v-validate="'required'" v-model="payOutDate" name="included" label="PayOut Date" class="select-large mt-5 w-full">
                                <vs-select-item :key="index" :value="item.createPayrollId" :text="item.payOutDate | fulldate" v-for="(item,index) in getAllCreatePayroll" />
                            </vs-select> -->
                            <span  class="text-sm">PayOut Date</span><span style="color:red">*</span>
                                <v-select v-validate="'required'"  name="payout_date" v-model="payOutDate" label="payOutDate"  :options="getAllCreatePayroll" placeholder="Please Select"/>
                            <span class="text-danger">{{ errors.first('step-1.payout_date') }}</span>
                        </div>
                        <div class="demo-alignment"  v-show="selected[4] === 'PayrollBankAdvise' ? true: false" >
                            <span  class="text-sm">Credit Date</span><span style="color:red">*</span>
                            <datepicker  v-model="creditDate" v-validate="'required'" placeholder="Credit Date" />
                        </div>
                    </div>

                    
                </div>
            <div class="flex justify-between flex-wrap mt-5">
                <span/>
                <vs-button @click="onSetPasswordToOpen()" color="success" type="filled" icon-pack="feather" icon="icon-download">Generate Reports</vs-button>
            </div>
            
        <!-- </vx-card> -->
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VueApexCharts from 'vue-apexcharts'
import analyticsData from '../../ui-elements/card/analyticsData.js'

import axios from '@/axios.js'
import Swal from 'sweetalert2'

export default {
    props: {
        createPayroll: {
            type: Array,
            required: false
        },
        
    },
    data() {
        return {
            counter         :0,
            percentage      :[0],
            creditDate: moment().format('DD MMM yyyy'),
            payOutDate: [],


            analyticsData,

            reportItems: [
                { value: 'PayrollEarnings', reportName: 'All Earnings'},
                { value: 'PayrollDeductions', reportName: 'All Deductions'},
                { value: 'PayrollLoans', reportName: 'All Loans'},
                { value: 'PayrollBankRemittance', reportName: ' BankDiskette'},
                { value: 'PayrollBankAdvise', reportName: ' Bank Advise'},
                { value: 'PayrollRegister', reportName: 'Payroll Register'},
                { value: 'PayrollRegisterProjectStaff', reportName: 'Payroll Register - Project'},
                // { value: 'PayrollSummary', reportName: 'Payroll Summary'},
                { value: 'PayrollProoflist', reportName: 'Payroll Prooflist'},
            ],
            // selected:[ "PayrollEarnings", "PayrollDeductions", "PayrollLoans", "PayrollBankRemittance", "PayrollBankAdvise", "PayrollRegister", "PayrollRegisterProjectStaff", "PayrollProoflist"],
            selected:[],
            passwordToOpen:''

            
        }
    },
    created() {
      this.$store.dispatch('payroll/getAllCreatePayroll')
            .then(() => {
                this.$vs.loading.close()
            })
            .catch((err) => { 
                this.$vs.loading.close()
                console.log(err) 
            })
    },
    computed: {
        getAllCreatePayroll() {
            return this.$store.state.payroll.getAllCreatePayroll
        },
        getAllPayOutDate() {
            let p = this.getAllCreatePayroll
            let payOutDate = []
            p.forEach(d => {
                payOutDate.push(Object.assign(d, { payOutDate: moment(d.payOutDate).format('YYYY-MM-DD')}))
            })
            return payOutDate
        },
        getAllLogHours() {
            return this.$store.state.payroll.getAllLogHours
        },
        tenantName() {
            return (id) => this.$store.getters['tenants/tenantName'](id)
        },
    },
    methods: {
        onGenerateReports() {
            
            
            this.percentageReport = [0]
            this.counterReports = 0
            let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId)
            var logoPath = ''
       
            if(tenant.photoId != null) {
                 this.$store.dispatch('getFile', tenant.photoId) //Get filePath of Company Logo
                    .then((response) => {
                        logoPath = response.data.path
                
                })
            }
        

            //Export Report in ZIP File
            const data = {
                serverName: tenant.secretKey,
                dbName: tenant.apiKey,
                userName: '',
                password: '',
                companyCode: tenant.code,
                companyName: tenant.name,
                address: tenant.address,
                photoURL: logoPath,
                createPayrollId: 0,//this.createPayroll.createPayrollId,
                printedBy: this.$store.state.AppActiveUser.uid,
                reportName:this.selected,//['PayrollSummary', 'PayrollEarnings'],
                payOutDate: moment(this.payOutDate).format('YYYYMMDD'),
                creditDate: this.creditDate,
                passwordToOpen: this.passwordToOpen,
                monthName: '',
                yearScope: '',
                reportType: 'PERIODIC',
                userId: [this.$store.state.AppActiveUser.uid]
            }
            // this.$vs.loading()
            this.$store.dispatch('payroll/GenerateReports', data)
            .then(() => {
                var zipFileName = tenant.code + '_' + moment(this.createPayroll.payOutDate).format('YYYYMMDD') + '.zip'
                var pDate = moment(this.createPayroll.payOutDate).format('YYYYMMDD')
                axios.get(`/api/reports/DownloadFile?dbName=${tenant.code}&fileName=${zipFileName}&payOutDate=${pDate}`
                ,{ reportProgress: true, responseType: 'blob' })
                    .then((response) => {
                            this.$vs.loading.close()
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', tenant.code + '_' + moment(this.createPayroll.payOutDate).format('YYYYMMDD') + '.zip');
                            document.body.appendChild(link);
                            link.click();
                            
                            Swal.fire({ title: 'Done', html: 'Reports Generated', icon:'success', timer: 2000, timerProgressBar: true,})
                    })
                    .catch((error) => {
                        this.$alert(error.message, 'Error', 'error')
                    })
            })
        },
        onSetPasswordToOpen() {
            Swal.fire({
                    title: 'Set Password',
                    input: 'password',
                    inputLabel: 'Password',
                    inputPlaceholder: 'Max of 10 characters',
                    inputAttributes: {
                    maxlength: 10,
                    autocapitalize: 'off',
                    autocorrect: 'off'
                }
            })
            .then((t) => {
                // console.log(t.value)
                this.passwordToOpen = t.value
                if(t.value == '') {
                    this.$alert("This is an important file and must have a password ", "Password Required", "info")
                } else {
                    this.onOpenWaitingDialog()
                }
            })
           
        },
        onOpenWaitingDialog() {
            Swal.fire({
                title: 'Generating Reports!',
                html: 'Please wait while report is generating...',
                timer: 2000,
                showConfirmButton: false,
                didOpen: () => {
                    this.onGenerateReports()
                },
                }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    // console.log('I was closed by the timer')
                }
            })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VueApexCharts,
        Swal,
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>